<template>
    <div class="cadastrohion ">
        <PageTitle icon="fas fa-user-lock iconInterativoTitulo" main="CADASTRO HION TECNOLOGIA"
            sub="Cadastro de Colaboradores" />

        <b-form class="ml-3 mr-3">
            <b-row>
                <b-col sm="12">
                    <b-form-group label="Nome Completo:" label-for="colaborador-nome">
                        <b-form-input id="colaborador-nome" type="text"
                            v-model="colaborador.nome_completo"
                            placeholder="Informe o nome completo do colaborador..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="CPF:" label-for="colaborador-cpf">
                        <b-input v-model="cpfId" :state="validaCPF" id="colaborador-cpf"
                            placeholder="Informe o CPF do colaborador..." />
                        <b-form-invalid-feedback :state="validaCPF">
                            CPF deve conter apenas 11 números
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaCPF">
                            Número de CPF Válido.
                        </b-form-valid-feedback>            
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="RG:" label-for="colaborador-rg">
                        <b-form-input id="colaborador-rg" type="text"
                            v-model="colaborador.rg"
                            placeholder="Informe o RG do colaborador..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Data de Nascimento:" label-for="colaborador-nascimento">
                        <b-form-input id="colaborador-nascimento" type="text"
                            v-model="dataId"
                            placeholder="Informe a data de nascimento do colaborador..." 
                            v-on:keyup="validarData(dataId)" />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="CEP:" label-for="colaborador-cep">
                        <b-form-input id="colaborador-cep" type="text"
                            v-model="cepId"
                            placeholder="Informe o CEP do colaborador..." 
                            v-on:keyup="validarCEP(cepId)" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Endereço:" label-for="colaborador-endereco">
                        <b-form-input id="colaborador-endereco" type="text"
                            v-model="colaborador.endereco"
                            placeholder="Informe o endereço do colaborador..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Número:" label-for="colaborador-numero">
                        <b-form-input id="colaborador-numero" type="text"
                            v-model="colaborador.numero"
                            placeholder="Informe o número da residência do colaborador" />
                    </b-form-group>
                </b-col>
                
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Complemento:" label-for="colaborador-complemento">
                        <b-form-input id="colaborador-complemento" type="text"
                            v-model="colaborador.complemento"
                            placeholder="Ex: Apto 3A, Casa Fundos etc..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Bairro:" label-for="colaborador-bairro">
                        <b-form-input id="colaborador-bairro" type="text"
                            v-model="colaborador.bairro"
                            placeholder="Informe o bairro do colaborador..." />
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Cidade:" label-for="colaborador-cidade">
                        <b-form-input id="colaborador-cidade" type="text"
                            v-model="colaborador.cidade"
                            placeholder="Informe a cidade do colaborador..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Estado:" label-for="colaborador-estado">
                        <b-form-select v-model="colaborador.estado" id="colaborador-estado"
                            :options="estadosBrasil">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Telefone:" label-for="colaborador-telefone">
                        <b-form-input id="colaborador-telefone" type="text"
                            v-model="colaborador.telefone"
                            placeholder="Telefone do colaborador... Ex: 1141234567"
                            v-on:keyup="validarTelefone(colaborador.telefone)" />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Celular:" label-for="colaborador-celular">
                        <b-form-input id="colaborador-celular" type="text"
                            v-model="colaborador.celular"
                            placeholder="Celular do colaborador... Ex: 11912345678"
                            v-on:keyup="validarCelular(colaborador.celular)" />
                    </b-form-group>
                </b-col> 
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="E-mail Hion:" label-for="colaborador-email">     
                        <b-input v-model="emailId" :state="validaEMAIL" id="colaborador-email"
                            placeholder="Informe o e-mail Hion do colaborador..." />
                        <b-form-invalid-feedback :state="validaEMAIL">
                            Insira um E-mail Hion válido. ex@hiontecnologia.com.br
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaEMAIL">
                            E-mail Hion Válido
                        </b-form-valid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Senha:" label-for="colaborador-hionacredita">
                        <b-input type="password" v-model="acreditaId" :state="validaAcredita" id="colaborador-hionacredita"
                            placeholder="Informe a senha (padrão=1234)..." />
                        <b-form-invalid-feedback :state="validaAcredita">
                            Insira qualquer combinação entre 8 e 12 dígitos
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validaAcredita">
                            Senha Hion Válida
                        </b-form-valid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Cargo:" label-for="colaborador-cargo">
                        <b-form-input id="colaborador-cargo" type="text"
                            v-model="colaborador.cargo"
                            placeholder="Informe o cargo do colaborador..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Categoria:" label-for="colaborador-categoria">
                        <b-form-select v-model="categoriaSelecionada" id="colaborador-categoria"
                            :options="categorias">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Banco:" label-for="colaborador-banco">
                        <b-form-input id="colaborador-banco" type="text"
                            v-model="colaborador.banco"
                            placeholder="Informe o Banco do colaborador..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Agência:" label-for="colaborador-agencia">
                        <b-form-input id="colaborador-agencia" type="text"
                            v-model="colaborador.agencia"
                            placeholder="Informe a agência e o dígito..." />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col md="6" sm="12">
                    <b-form-group label="Conta Corrente:" label-for="colaborador-cc">
                        <b-form-input id="colaborador-cc" type="text"
                            v-model="colaborador.cc"
                            placeholder="Número da conta corrente do colaborador..." />
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12">
                    <b-form-group label="Status:" label-for="colaborador-status">
                        <b-form-select v-model="statusSelecionado" id="colaborador-status"
                            :options="status">
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <b-form-group label="Anotações Gerais:" label-for="colaborador-anotacoes">
                        <b-form-textarea id="colaborador-anotacoes" type="text"
                            v-model="colaborador.anotacoes"
                            placeholder="Efetue anotações gerais e pertinentes ao referente colaborador..."
                            rows="5"
                            max-rows="10" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col xs="12">
                    <b-button variant="primary"
                        @click="save">Cadastrar Colaborador</b-button>
                    <b-button class="ml-2" @click="reset">Cancelar</b-button>
                </b-col>
            </b-row>

        </b-form>

        <hr class="ml-2 mr-2">
        
    </div>
</template>

<script>
import VueScrollTo from 'vue-scrollto'
import PageTitle from '../PageTitle'
import { baseApiUrl, userKey, showError } from '../../../global'
import axios from 'axios'

export default {
    name: 'CadastroHion',
    components: { PageTitle } ,
    data: function() {
        return {
            colaborador: { estado: null },
            categoriaSelecionada: null,
            statusSelecionado: null,
            cpfId: '',
            cepId: '',
            validaCEP: false,
            validaCelular: false,
            validaTeefone: false,
            emailId: '',
            acreditaId: '',
            dataId: '',
            validaData: false,
            estadosBrasil: [
                { value: null, text: 'Selecione o Estado' },
                { value: 'AC', text: 'Acre (AC)' },
                { value: 'AL', text: 'Alagoas (AL)' },
                { value: 'AP', text: 'Amapá (AP)' },
                { value: 'AM', text: 'Amazonas (AM)' },
                { value: 'BA', text: 'Bahia (BA)' },
                { value: 'CE', text: 'Ceará (CE)' },
                { value: 'DF', text: 'Distrito Federal (DF)' },
                { value: 'ES', text: 'Espírito Santo (ES)' },
                { value: 'GO', text: 'Goiás (GO)' },
                { value: 'MA', text: 'Maranhão (MA)' },
                { value: 'MT', text: 'Mato Grosso (MT)' },
                { value: 'MS', text: 'Mato Grosso do Sul (MS)' },
                { value: 'MG', text: 'Minas Gerais (MG)' },
                { value: 'PA', text: 'Pará (PA)' },
                { value: 'PB', text: 'Paraíba (PB)' },
                { value: 'PR', text: 'Paraná (PR)' },
                { value: 'PE', text: 'Pernambuco (PE)' },
                { value: 'PI', text: 'Piauí (PI)' },
                { value: 'RJ', text: 'Rio de Janeiro (RJ)' },
                { value: 'RN', text: 'Rio Grande do Norte (RN)' },
                { value: 'RS', text: 'Rio Grande do Sul (RS)' },
                { value: 'RO', text: 'Rondônia (RO)' },
                { value: 'RR', text: 'Roraima (RR)' },
                { value: 'SC', text: 'Santa Catarina (SC)' },
                { value: 'SP', text: 'São Paulo (SP)' },
                { value: 'SE', text: 'Sergipe (SE)' },
                { value: 'TO', text: 'Tocantins (TO)' }
            ],
            categorias: [
                { value: null, text: 'Selecione a categoria' },
                { value: 'socio', text: 'Sócio' },
                { value: 'dev', text: 'Desenvolvedor' },
                { value: 'admin', text: 'Administrativo' },
                { value: 'campo', text: 'Técnico Campo' },
            ],
            status: [
                { value: null, text: 'Status inicial do colaborador' },
                { value: 'ativo', text: 'Ativo' },
                { value: 'inativo', text: 'Inativo' },
                { value: 'ferias', text: 'Férias' },
                { value: 'afastado', text: 'Afastado' },
                { value: 'suspenso', text: 'Suspenso' },
                { value: 'desligado', text: 'Desligado' },
            ]
        }
    },
    computed: {
        validaCPF() { return this.validarCPF(this.cpfId) },
        validaEMAIL() { return this.validarEmail(this.emailId) },
        validaAcredita() { return this.validarHionAcredita(this.acreditaId) }
    },
    methods: {
        
        save(evt) {
            evt.preventDefault()          //previne comportamento padrao ao clicar no botao enviar

            //Realiza uma série de validações antes de submeter o formulário para o servidor Hion
            ////////////////////////////////////////////////////////////////////////////////////////
            if((this.colaborador.nome_completo === '') || (this.colaborador.nome_completo === undefined))  {
               this.$toasted.global.defaultInfo({ msg : 'Por favor insira o nome do colaborador!' });
               VueScrollTo.scrollTo('#colaborador-nome');
               document.getElementById("colaborador-nome").focus()
               return
            }
            if(this.cpfId === '') {
               this.$toasted.global.defaultInfo({ msg : 'Por favor insira o CPF do colaborador!' })
               VueScrollTo.scrollTo('#colaborador-cpf');
               document.getElementById("colaborador-cpf").focus()
               return
            }
            if(!this.validaCPF) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor insira um CPF válido!' })
                VueScrollTo.scrollTo('#colaborador-cpf');
                document.getElementById("colaborador-cpf").focus()
                return
            }

            let SoNumero = this.cpfId.replace(/\D/g, '');
            this.colaborador.cpf = SoNumero    //se CPF for validado , carrega CPF no objeto de saida

            if((this.colaborador.rg === '') || (this.colaborador.rg === undefined))  {
               this.$toasted.global.defaultInfo({ msg : 'Por favor insira o RG do colaborador!' })
               VueScrollTo.scrollTo('#colaborador-rg');
               document.getElementById("colaborador-rg").focus()
               return
            }
            if((this.colaborador.rg.length <= 6) || (this.colaborador.rg.length >= 13))  {
                this.$toasted.global.defaultInfo({ msg : 'Por favor insira um RG válido!' })
                VueScrollTo.scrollTo('#colaborador-rg');
                document.getElementById("colaborador-rg").focus()
                return
            }


            if((this.dataId === '') || (this.dataId === undefined))  {
               this.$toasted.global.defaultInfo({ msg : 'Por favor informe a data de nascimento do colaborador!' })
               VueScrollTo.scrollTo('#colaborador-nascimento');
               document.getElementById("colaborador-nascimento").focus()
               return
            }
            if(!this.validaData) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe uma data de nascimento válida!' })
                VueScrollTo.scrollTo('#colaborador-nascimento');
                document.getElementById("colaborador-nascimento").focus()
                return
            }

            this.colaborador.nascimento = this.converteData(this.dataId)//se Nascimento for validado , carrega Data no objeto de saida


            if(this.cepId === '') {
               this.$toasted.global.defaultInfo({ msg : 'Por favor informe o CEP do colaborador!' })
               VueScrollTo.scrollTo('#colaborador-cep');
               document.getElementById("colaborador-cep").focus()
               return
            }
            if(!this.validaCEP) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um CEP válido!' })
                VueScrollTo.scrollTo('#colaborador-cep');
                document.getElementById("colaborador-cep").focus()
                return
            }

            this.colaborador.cep = this.cepId       //se CEP for validado , carrega Data no objeto de saida 

            if((this.colaborador.endereco === '') || (this.colaborador.endereco === undefined))  {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe o endereço do colaborador!' })
                VueScrollTo.scrollTo('#colaborador-endereco');
                document.getElementById("colaborador-endereco").focus()
               return
            }

            if((this.colaborador.numero === '') || (this.colaborador.numero === undefined))  {
                this.$toasted.global.defaultInfo({ msg : 'Por favor insira o número da residência do colaborador!' })
                VueScrollTo.scrollTo('#colaborador-numero');
                document.getElementById("colaborador-numero").focus()
                return
            }

            if((this.colaborador.bairro === '') || (this.colaborador.bairro === undefined))  {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe o bairro do colaborador!' })
                VueScrollTo.scrollTo('#colaborador-bairro');
                document.getElementById("colaborador-bairro").focus()
               return
            }

            if((this.colaborador.cidade === '') || (this.colaborador.cidade === undefined))  {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe a cidade do colaborador!' })
                VueScrollTo.scrollTo('#colaborador-cidade');
                document.getElementById("colaborador-cidade").focus()
                return
            }

            if(this.colaborador.estado === null) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe o estado!' })
                VueScrollTo.scrollTo('#colaborador-estado');
                document.getElementById("colaborador-estado").focus()
               return
            }

            if(!((this.colaborador.telefone === '') || (this.colaborador.telefone === undefined))) {
                if(!this.validaTelefone) {
                    this.$toasted.global.defaultInfo({ msg : 'Por favor informe um número de telefone válido!' })
                    VueScrollTo.scrollTo('#colaborador-telefone');
                    document.getElementById("colaborador-telefone").focus()
                    return
                }
            }
    
            if((this.colaborador.celular === '') || (this.colaborador.celular === undefined)) {
               this.$toasted.global.defaultInfo({ msg : 'Por favor informe o celular do colaborador!' })
                VueScrollTo.scrollTo('#colaborador-celular');
                document.getElementById("colaborador-celular").focus()
               return
            }
            if(!this.validaCelular) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um celular válido!' })
                VueScrollTo.scrollTo('#colaborador-celular');
                document.getElementById("colaborador-celular").focus()
                return
            }

            if(this.emailId === '') {
                this.$toasted.global.defaultInfo({ msg : 'Por favor insira o E-mail Hion do colaborador!' })
                VueScrollTo.scrollTo('#colaborador-email');
                document.getElementById("colaborador-email").focus()
               return
            }
            if(!this.validaEMAIL) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe um e-mail Hion válido!' })
                VueScrollTo.scrollTo('#colaborador-email');
                document.getElementById("colaborador-email").focus()
                return
            }

            this.colaborador.email_hion = this.emailId;

            if (this.statusSelecionado === null) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe a status que o colaborador se enquadra!' })
                VueScrollTo.scrollTo('#colaborador-status');
                document.getElementById("colaborador-status").focus()
                return
            } else {
                this.colaborador.status = this.statusSelecionado;
            }

            if (this.categoriaSelecionada === null) {
                this.$toasted.global.defaultInfo({ msg : 'Por favor informe a categoria que o colaborador se enquadra!' })
                VueScrollTo.scrollTo('#colaborador-categoria');
                document.getElementById("colaborador-categoria").focus()
                return
            } else {
                switch (this.categoriaSelecionada) {
                    case 'socio':
                        this.colaborador.socio = true;
                        this.colaborador.dev = false;
                        this.colaborador.admin = false;
                        this.colaborador.campo = false;
                        if (this.colaborador.status == 'ativo' ||
                            this.colaborador.status == 'ferias' ) 
                                this.colaborador.privilegio = 0b11111111;
                            else this.colaborador.privilegio = 0b11111110;
                        break;
                    case 'dev':
                        this.colaborador.socio = false;
                        this.colaborador.dev = true;
                        this.colaborador.admin = false;
                        this.colaborador.campo = false;
                        if (this.colaborador.status == 'ativo' ||
                            this.colaborador.status == 'ferias' )
                                this.colaborador.privilegio = 0b00000011;
                            else this.colaborador.privilegio = 0b00000010;
                        break;
                    case 'admin':
                        this.colaborador.socio = false;
                        this.colaborador.dev = false;
                        this.colaborador.admin = true;
                        this.colaborador.campo = false;
                        if (this.colaborador.status == 'ativo' ||
                            this.colaborador.status == 'ferias' )
                                this.colaborador.privilegio = 0b00001001;
                            else this.colaborador.privilegio = 0b00001000;
                        break;
                    case 'campo':
                        this.colaborador.socio = false;
                        this.colaborador.dev = false;
                        this.colaborador.admin = false;
                        this.colaborador.campo = true;
                        if (this.colaborador.status == 'ativo' ||
                            this.colaborador.status == 'ferias' )
                                this.colaborador.privilegio = 0b00000011;
                            else this.colaborador.privilegio = 0b00000010;
                        break;
                    default:
                         this.$toasted.global.defaultError({ msg : 'Algo errado com o enquadramento de categoria!' });
                         VueScrollTo.scrollTo('#colaborador-categoria');
                         document.getElementById("colaborador-categoria").focus()
                         return;
                }
            }

            if(this.acreditaId === '') {
                this.colaborador.hionacredita = '';
            } else {
                if (!this.validaAcredita) {
                    this.$toasted.global.defaultInfo({ msg : "Senha inválida - Escolha uma combinação entre 8 e 12 caracteres!" });
                    VueScrollTo.scrollTo('#colaborador-hionacredita');
                    document.getElementById("colaborador-hionacredita").focus()
                    return
                } else {
                    this.colaborador.hionacredita = this.acreditaId;
                }
            }

            ////////////////////////////////////////////////////////////////////////////////////////
            ///////////////////////////////////////////////////////////////////////////////////////
            //Se passou por todas as validações, submete formulário para servidor Hion

            //seta usuario ficticio para testes no DEV
            /*const payload = {
                atual: {
                    id: 1,
                    nome_razao: "Bruno",
                    cpf_cnpj: "22813828399",
                    email: "bruno.dias@hiontecnologia.com.br",
                    hion: true,
                    admin: true,
                    nivel: 0,
                    prt: 0xff,
                },
                token: "c-137"
            }
            //this.$store.commit('setUser', payload)
            localStorage.setItem(userKey, JSON.stringify(payload))
            */

            //Adquiri o usuario atual da requisição
            const json = localStorage.getItem(userKey);
            const userData = JSON.parse(json);

            //Monta pacote para envio ao servidor
            const pacote = {
                usuario: userData,
                colaborador: this.colaborador
            }

            axios.post(`${baseApiUrl}/cadastroHion`, pacote)
                .then((res) => {
                    if (res.status == 200) {
                        this.$toasted.global.defaultSuccess({ msg : 'Colaborador cadastrado com sucesso!' })
                        if(this.colaborador.hionacredita === '') this.$toasted.global.defaultInfo({ msg : 'Colaborador cadastrado conforme padrão!' })
                        //this.reset()            //Ao concluir o cadastro reseta os valores de todos os campos
                    }
                })
                .catch(showError)
        },
        reset() {
            this.colaborador = {};
            this.colaborador = { estado: null };
            this.statusSelecionado = null;
            this.cpfId = '';
            this.dataId = '';
            this.validaCPF = false;
            this.validaData = false;
            this.validaCelular = false;
            this.validaTelefone = false;
            this.cepId = '';
            this.validaCEP = false;
            this.emailId = '';
            this.acreditaId = '';
            this.categoriaSelecionada = null;
        },
        validarCPF(inputCPF){
            let soma = 0;
            let resto;

            if(inputCPF == '00000000000') return false;
            for(let i=1; i<=9; i++) soma = soma + parseInt(inputCPF.substring(i-1, i)) * (11 - i);
            resto = (soma * 10) % 11;

            if((resto == 10) || (resto == 11)) resto = 0;
            if(resto != parseInt(inputCPF.substring(9, 10))) return false;

            soma = 0;
            for(let i = 1; i <= 10; i++) soma = soma + parseInt(inputCPF.substring(i-1, i))*(12-i);
            resto = (soma * 10) % 11;

            if((resto == 10) || (resto == 11)) resto = 0;
            if(resto != parseInt(inputCPF.substring(10, 11))) return false;
            if(inputCPF.length == 11) return true;
            return false;
        },
        validarData(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor)) && isFinite(valor)) {
                        if (valor[0] >= 4) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido > 31 dias'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = '';
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = '';
                    }
                    break;
                case 2:
                    if(!isNaN(parseFloat(valor[1])) && isFinite(valor[1])) {
                        if (valor[0] == 3 && valor[1] >= 2) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido > 31 dias'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}`;
                        }
                        if (valor[0] == 0 && valor[1] == 0) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido < 1 dia'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = `${valor[0]}`;
                    }
                    break;
                case 3:
                    if (valor[2] !== '/') {
                        if(!isNaN(parseFloat(valor[2])) && isFinite(valor[2])) {
                            if (valor[2] >= 2) {
                                this.$toasted.global.defaultInfo({ msg : 'Mês inválido > 12 meses'});
                                VueScrollTo.scrollTo('#colaborador-nascimento');
                                document.getElementById("colaborador-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}/`;
                            } else valor = `${valor[0]}${valor[1]}/${valor[2]}`;
                        } else {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}/`;
                        }
                    }
                    break;
                case 4:
                    if(!isNaN(parseFloat(valor[3])) && isFinite(valor[3])) {
                            if (valor[3] >= 2) {
                                this.$toasted.global.defaultInfo({ msg : 'Mês inválido > 12 meses'});
                                VueScrollTo.scrollTo('#colaborador-nascimento');
                                document.getElementById("colaborador-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}/`;
                            } else valor = `${valor[0]}${valor[1]}/${valor[3]}`;
                        } else {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}/`;
                        }
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        if (valor[3] == 1 && valor[4] >= 3) {
                            this.$toasted.global.defaultInfo({ msg : 'Mês inválido > 12 meses'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                        }
                        if (valor[3] == 0 && valor[4] == 0) {
                            this.$toasted.global.defaultInfo({ msg : 'Dia do mês inválido < 1 mês'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                    }
                    break;
                 case 6:
                    if (valor[5] !== '/') {
                        if(!isNaN(parseFloat(valor[5])) && isFinite(valor[5])) {
                            if (valor[5] <= 0 || valor[5] >= 3) {
                                this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                VueScrollTo.scrollTo('#colaborador-nascimento');
                                document.getElementById("colaborador-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}/`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}/${valor[5]}`;
                        } else {
                            this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}/`;
                        }
                    }
                    break;
                case 7:
                    if(!isNaN(parseFloat(valor[6])) && isFinite(valor[6])) {
                        if (valor[6] <= 0 || valor[6] >= 3) {
                            this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                            VueScrollTo.scrollTo('#colaborador-nascimento');
                            document.getElementById("colaborador-nascimento").focus()
                            valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                        } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                    }
                    break;
                case 8:
                    if(!isNaN(parseFloat(valor[7])) && isFinite(valor[7])) {
                        if (valor[6] == 1) {
                            if (!(valor[7] == 8 || valor[7] == 9)) {
                                 this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                VueScrollTo.scrollTo('#colaborador-nascimento');
                                document.getElementById("colaborador-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                        }
                        if (valor[6] == 2) {
                            if (!(valor[7] == 0)) {
                                 this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                VueScrollTo.scrollTo('#colaborador-nascimento');
                                document.getElementById("colaborador-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                        }
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    }
                    break;
                case 9:
                    if(!isNaN(parseFloat(valor[8])) && isFinite(valor[8])) {
                        if (valor[6] == 2 && valor[7] == 0) {
                            if (valor[8] >= 2) { //bloqueio nascimentos após 2020
                                 this.$toasted.global.defaultInfo({ msg : 'Ano inválido'});
                                 VueScrollTo.scrollTo('#colaborador-nascimento');
                                document.getElementById("colaborador-nascimento").focus()
                                valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                            } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                        } else valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    }
                    break;
                case 10:
                    if(!isNaN(parseFloat(valor[9])) && isFinite(valor[9])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}`;
                        this.validaData = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números na data de nascimento'});
                        VueScrollTo.scrollTo('#colaborador-nascimento');
                        document.getElementById("colaborador-nascimento").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                        this.validaData = false;
                    }
                    break;
                case 11:
                    this.$toasted.global.defaultInfo({ msg : 'Por favor apenas insira uma data de nascimento válida'});
                    VueScrollTo.scrollTo('#colaborador-nascimento');
                    document.getElementById("colaborador-nascimento").focus()
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    break;
            }
            this.dataId = valor;
            document.getElementById('colaborador-nascimento').value=(this.dataId);
        },
        converteData(inputData) {
            let SoNumero = inputData.replace(/\D/g, '');
            return `${SoNumero[4]}${SoNumero[5]}${SoNumero[6]}${SoNumero[7]}-${SoNumero[2]}${SoNumero[3]}-${SoNumero[0]}${SoNumero[1]}`;
        },
        validarCEP(inputCEP) {
            //Nova variável "cep" somente com dígitos.
            let cep = inputCEP.replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "") {
                //Expressão regular para validar o CEP.

                if((!isNaN(parseFloat(cep)) && isFinite(cep)) && (cep.length >= 5) && (cep.length <= 12)) {       //Obriga entrada ser apenas de números
                    //Valida o formato do CEP.
                    axios.get("https://viacep.com.br/ws/"+ cep +"/json/")
                        .then((dados) => {
                            if (!("erro" in dados)) {
                                this.colaborador.endereco = dados.data.logradouro;
                                document.getElementById('colaborador-endereco').value=(this.colaborador.endereco);
                                this.colaborador.bairro = dados.data.bairro;
                                document.getElementById('colaborador-bairro').value=(this.colaborador.bairro);
                                this.colaborador.cidade = dados.data.localidade;
                                document.getElementById('colaborador-cidade').value=(this.colaborador.cidade);
                                this.colaborador.estado = dados.data.uf;
                                document.getElementById('colaborador-estado').value=(this.colaborador.estado);
                            } else this.$toasted.global.defaultError({ msg : "Erro ao consultar CEP" });
                        })
                } //end if.
                else {
                    //cep é inválido.
                    this.validaCEP = false;
                    return
                }
            } //end if.
            else {
                //cep sem valor, limpa formulário.
                this.validaCEP = false;
                return
            }
            this.validaCEP = true;
        },
        validarTelefone(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor[0])) && isFinite(valor[0])) {
                        valor = `(${valor[0]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = ``;
                    }
                    this.validaTelefone = false;
                    break;     
                case 3:
                    if(!isNaN(parseFloat(valor[2])) && isFinite(valor[2])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]})`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]} ${valor[4]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 7:
                    if(!isNaN(parseFloat(valor[6])) && isFinite(valor[6])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 8:
                    if(!isNaN(parseFloat(valor[7])) && isFinite(valor[7])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 9:
                    if(!isNaN(parseFloat(valor[8])) && isFinite(valor[8])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 10:
                    if(!isNaN(parseFloat(valor[9])) && isFinite(valor[9])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}-${valor[9]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 12:
                    if(!isNaN(parseFloat(valor[11])) && isFinite(valor[11])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 13:
                    if(!isNaN(parseFloat(valor[12])) && isFinite(valor[12])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    }
                    this.validaTelefone = false;
                    break;
                case 14:
                    if(!isNaN(parseFloat(valor[13])) && isFinite(valor[13])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaTelefone = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                        this.validaTelefone = false;
                    }
                    break;
                case 15:
                    if(!isNaN(parseFloat(valor[14])) && isFinite(valor[14])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[10]}${valor[9]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                        this.validaTelefone = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no telefone!'});
                        VueScrollTo.scrollTo('#colaborador-telefone');
                        document.getElementById("colaborador-telefone").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaTelefone = false;
                    }
                    break;
                case 16:
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                    this.$toasted.global.defaultInfo({ msg : 'Quantidade de números excedida. Ex: (11) 11111-1111'});
                    VueScrollTo.scrollTo('#colaborador-telefone');
                    document.getElementById("colaborador-telefone").focus()
                    this.validaTelefone = false;
                    break;  
            }
            this.colaborador.telefone = valor;
            document.getElementById('colaborador-telefone').value=(this.colaborador.telefone);
        },
        validarCelular(inputData) {
            let valor = inputData;
            
            switch (valor.length) {
                case 1:
                    if(!isNaN(parseFloat(valor[0])) && isFinite(valor[0])) {
                        valor = `(${valor[0]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = ``;
                    }
                    this.validaCelular = false;
                    break;     
                case 3:
                    if(!isNaN(parseFloat(valor[2])) && isFinite(valor[2])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]})`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 5:
                    if(!isNaN(parseFloat(valor[4])) && isFinite(valor[4])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]} ${valor[4]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 7:
                    if(!isNaN(parseFloat(valor[6])) && isFinite(valor[6])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 8:
                    if(!isNaN(parseFloat(valor[7])) && isFinite(valor[7])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 9:
                    if(!isNaN(parseFloat(valor[8])) && isFinite(valor[8])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 10:
                    if(!isNaN(parseFloat(valor[9])) && isFinite(valor[9])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}-${valor[9]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 12:
                    if(!isNaN(parseFloat(valor[11])) && isFinite(valor[11])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 13:
                    if(!isNaN(parseFloat(valor[12])) && isFinite(valor[12])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}`;
                    }
                    this.validaCelular = false;
                    break;
                case 14:
                    if(!isNaN(parseFloat(valor[13])) && isFinite(valor[13])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaCelular = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}`;
                        this.validaCelular = false;
                    }
                    break;
                case 15:
                    if(!isNaN(parseFloat(valor[14])) && isFinite(valor[14])) {
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[10]}${valor[9]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                        this.validaCelular = true;
                    } else {
                        this.$toasted.global.defaultInfo({ msg : 'Por favor insira somente números no celular!'});
                        VueScrollTo.scrollTo('#colaborador-celular');
                        document.getElementById("colaborador-celular").focus()
                        valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}`;
                        this.validaCelular = false;
                    }
                    break;
                case 16:
                    valor = `${valor[0]}${valor[1]}${valor[2]}${valor[3]}${valor[4]}${valor[5]}${valor[6]}${valor[7]}${valor[8]}${valor[9]}${valor[10]}${valor[11]}${valor[12]}${valor[13]}${valor[14]}`;
                    this.$toasted.global.defaultInfo({ msg : 'Quantidade de números excedida. Ex: (11) 11111-1111'});
                    VueScrollTo.scrollTo('#colaborador-celular');
                    document.getElementById("colaborador-celular").focus()
                    this.validaCelular = false;
                    break;  
            }
            this.colaborador.celular = valor;
            document.getElementById('colaborador-celular').value=(this.colaborador.celular);
        },
        validarEmail(email) {
            let emailPattern =  /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
            return emailPattern.test(email); 
        },
        validarHionAcredita(acredita) {
            if ((acredita.length >= 8) && (acredita.length <= 12)) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted() {
        this.reset()
    }
}
</script>

<style>
    .cadastrohion {
        position: relative;
        width: 100%;
        height: 100%;
    }
</style>